import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';
import type { CatalogFilterKey } from '@/types/Sixes';

export const selectCatalogState = (state: RootState) => state.sixCatalog;

export const selectCatalogSixes = createSelector(
  selectCatalogState,
  (catalog) => catalog.sixes
);

export const selectCatalogHasLoaded = createSelector(
  selectCatalogState,
  (catalog) => catalog.hasLoaded
);

export const selectCatalogSearch = createSelector(
  selectCatalogState,
  (catalog) => catalog.search
);

export const selectCatalogFilters = createSelector(
  selectCatalogState,
  (catalogState) => catalogState.filters
);

export const selectIsCatalogFilterActive = (filterKey: CatalogFilterKey) =>
  createSelector(selectCatalogFilters, (activeFilters) => activeFilters.includes(filterKey));

export const selectCatalogSortField = createSelector(
  selectCatalogState,
  (catalog) => catalog.sortField
);

export const selectCatalogSortDirection = createSelector(
  selectCatalogState,
  (catalog) => catalog.sortDirection
);
